export default __webpack_public_path__ + "static/media/IMG_6760 - Copy - Copy.ea7c015d.jpg";